var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    comboItems: _vm.gubunItems,
                    type: "none",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "gubun",
                    label: "조회구분",
                  },
                  on: { datachange: _vm.datachange },
                  model: {
                    value: _vm.searchParam.gubun,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "gubun", $$v)
                    },
                    expression: "searchParam.gubun",
                  },
                }),
              ],
              1
            ),
            _vm.searchParam.gubun === "chemNm"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                  },
                  [
                    _c("c-text", {
                      attrs: {
                        required: "",
                        name: "chemNm",
                        label: "화학물질영문명 (2자 이상 입력)",
                      },
                      model: {
                        value: _vm.searchParam.chemNm,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "chemNm", $$v)
                        },
                        expression: "searchParam.chemNm",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.searchParam.gubun === "casNo"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                  },
                  [
                    _c("c-text", {
                      attrs: {
                        required: "",
                        name: "casNo",
                        label: "CAS No. (2자 이상 입력)",
                      },
                      model: {
                        value: _vm.searchParam.casNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "casNo", $$v)
                        },
                        expression: "searchParam.casNo",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "화학물질 목록",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            gridHeight: _vm.grid.height,
            isExcelDown: false,
            isFullScreen: false,
            columnSetting: false,
            selection: _vm.popupParam.type,
            rowKey: "mdmChemId",
          },
          on: { rowDblclick: _vm.rowDblclick, linkClick: _vm.linkClick },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: { label: "LBLSELECT", icon: "check" },
                        on: { btnClicked: _vm.select },
                      })
                    : _vm._e(),
                  _c("c-btn", {
                    attrs: { label: "LBLSEARCH", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }